import { observable, action, computed, intercept } from "mobx";
import { post } from "../services/ajax.service";


class AlternativeFundingStore {
  @observable not_found = false;
  @observable target_spend = 0;
  @observable alternative_funding_spend = 0;
  @observable drug_spend = [];
  @observable drug_count = 0;
  @observable unique_par = 0;
  @observable participant_count = 0;
  @observable url = "/api/v1/recommendationactions/AlternativeFunding";
  constructor() {
    intercept(this, change => {
      if (change.newValue == null || change.newValue == 0) {
        localStorage.setItem("not_found", true)
      } else if (change.newValue != null || change.newValue != 0) {
        localStorage.setItem("not_found", false)
      }
      return change;
    })
  }
  @computed get potential_savings() {
    return (
      this.target_spend - this.alternative_funding_spend
    );
  }
  @action getTargetSpend = async (data) => {
    this.target_spend = 0;
    try {
      let response = await post(
        `${this.url}/getTargetSpend`,
        data
      );

      this.target_spend = response.data[0].TARGET_SPEND;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTotalParticipants = async (data) => {
    try {
      let response = await post(
        `${this.url}/getTotalParticipants`,
        data
      );



      this.participant_count = response.data[0].unique_par;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugCount = async (data) => {
    this.drug_count = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCount`,
        data
      );
      this.drug_count = response.data[0].drug_count;
      this.unique_par = response.data[0].unique_par;
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxTourismSpend = async (data) => {
    this.alternative_funding_spend = 0;
    try {
      let response = await post(
        `${this.url}/getRxTourismSpend`,
        data
      );

      this.alternative_funding_spend = response.data[0].RX_TOURISM_SPEND;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugSpend = async (data) => {
    this.drug_spend = [];
    try {
      let response = await post(
        `${this.url}/getDrugSpend`,
        data
      );

      this.drug_spend = response.data;
    } catch (err) {
      console.log(err);
    }
  }

}

export default AlternativeFundingStore;
